// extracted by mini-css-extract-plugin
export var chevron = "_la-4";
export var chevronExpanded = "_la-5";
export var row = "_la-0";
export var rowBody = "_la-6";
export var rowDescription = "_la-7";
export var rowHeader = "_la-1";
export var rowTitle = "_la-2";
export var rowTitleComplete = "_la-3";